import oa from '../../asset/img/oa-icon.png';
import ehr from '../../asset/img/ehr-icon.png';
import wywk from '../../asset/img/wywk-icon.png';
import sports from '../../asset/img/sports-icon.png';
import eoms from '../../asset/img/eoms-icon.png';
import cdp from '../../asset/img/cdp-icon.png';
import lts from '../../asset/img/lts-icon.png';
import pms from '../../asset/img/pms-icon.png';
import brand from '../../asset/img/brand-icon.png';
import mdm from '../../asset/img/mdm-icon.png';
import pos from '../../asset/img/pos-icon.png';
import srm from '../../asset/img/srm-icon.png';
import s2b2c from '../../asset/img/s2b2c-icon.png';
import yq from '../../asset/img/yq-icon.png';
import tb from '../../asset/img/tb-icon.png';
import gitlab from '../../asset/img/gitLab-icon.png';
import rd from '../../asset/img/rd-icon.png';
import qa from '../../asset/img/qa-icon.png';
import jenkins from '../../asset/img/jenkins-icon.png';
import sso from '../../asset/img/sso-icon.png';
import ops from '../../asset/img/ops-icon.png';
import sonar from '../../asset/img/sonar-icon.png';
import arm from '../../asset/img/arm-icon.png';
import nexus from '../../asset/img/nexus-icon.png';
import cloud from '../../asset/img/cloud-icon.png';
import grafana from '../../asset/img/grafana-icon.png';
import dba from '../../asset/img/dba-icon.png';
import sentry from '../../asset/img/sentry-icon.png';
import npm from '../../asset/img/npm-icon.png';
import feTools from '../../asset/img/feTools-icon.png';
import rui from '../../asset/img/rui-icon.png';
import max from '../../asset/img/max-icon.png';
import email from '../../asset/img/email-icon.png';

export const currencyMap = [
  {
    title: 'OA',
    subTitle: '办公自动化系统',
    url: 'https://wyoa.wywk.cn',
    img: oa,
    key: 'OA',
  },
  {
    title: 'eHR',
    subTitle: '人力资源管理系统',
    url: 'https://ehr.playfordream.cn',
    img: ehr,
    key: 'EHR',
  },
  {
    title: '邮箱',
    subTitle: '企业邮箱',
    url: 'http://mail.wywk.cn/',
    img: email,
    key: 'MAIL',
  },
  {
    title: '网鱼官网',
    subTitle: '网鱼官网',
    url: 'https://www.wywk.cn',
    img: wywk,
    key: 'WYWK',
  },
  {
    title: '网鱼竞技场',
    subTitle: '网鱼竞技场官网',
    url: 'https://www.wywkygc.com',
    img: sports,
    key: 'SPORTS',
  },
];

export const businessMap = [
  {
    subTitle: '企业运营管理平台',
    title: 'EOMS',
    url: 'https://eoms.wywk.cn',
    img: eoms,
    key: 'EOMS',
  },
  {
    subTitle: '用户数据平台',
    title: 'CDP',
    url: 'https://cdp.wywk.cn',
    img: cdp,
    key: 'CDP',
  },
  {
    subTitle: '千鱼千寻销售管理系统',
    title: 'YooLTS',
    url: 'https://lts.wywk.cn',
    img: lts,
    key: 'YooLTS',
  },
  {
    subTitle: '电酒管理系统门店端',
    title: 'YooPMS',
    url: 'https://pms.wy-hotel.cn',
    img: pms,
    key: 'YooPMS',
  },
  {
    title: '电酒房价牌',
    subTitle: '电酒房价牌门店web端',
    url: 'https://price-brand.wywk.cn',
    img: brand,
    key: 'BRAND',
  },
  {
    subTitle: '主数据管理',
    title: 'MDM',
    url: 'https://mdm.wywk.cn',
    img: mdm,
    key: 'MDM',
  },
  {
    subTitle: '网咖门店销售系统',
    title: 'YooPOS',
    url: 'https://pos-kronos.wywk.cn',
    img: pos,
    key: 'YooPOS',
  },
  {
    subTitle: '供应商管理系统',
    title: 'SRM',
    url: 'https://srm.wywk.cn/wywk/system/login',
    img: srm,
    key: 'SRM',
  },
  {
    subTitle: '供应链商城管理端',
    title: 'Mall',
    url: 'https://ego.wanyoo.com.cn/pcenter/',
    img: s2b2c,
    key: 'S2B2C',
  },
];
export const researchMap = [
  {
    title: '语雀',
    subTitle: '文档管理平台',
    url: 'https://playfordream.yuque.com/',
    img: yq,
    key: 'YQ',
  },
  {
    title: 'Teambition',
    subTitle: '项目管理平台',
    url: 'https://www.teambition.com/',
    img: tb,
    key: 'TB',
  },
  {
    title: 'GitLab',
    subTitle: '代码仓库',
    url: 'https://gitlab.wywk.cn',
    img: gitlab,
    key: 'GITLAB',
  },
  {
    title: 'R&D',
    subTitle: '研发管理平台',
    url: 'https://rdmp.wywk.cn',
    img: rd,
    key: 'RD',
  },
  {
    title: 'QA',
    subTitle: '质量管理平台',
    url: 'https://qa.wywk.cn',
    img: qa,
    key: 'QA',
  },
  {
    title: 'Jenkins',
    subTitle: '发布平台',
    url: 'https://jenkins.wywk.cn',
    img: jenkins,
    key: 'JENKINS',
  },
  {
    title: 'SSO',
    subTitle: '单点登录平台',
    url: 'https://wysso.wywk.cn',
    img: sso,
    key: 'SSO',
  },
  {
    title: '堡垒机',
    subTitle: '堡垒机',
    url: 'https://jumpserver.ops.wydj.work',
    img: ops,
    key: 'OPS',
  },
  {
    title: 'Sonar',
    subTitle: 'Sonar质量管理',
    url: 'https://sonar.ops.wydj.work',
    img: sonar,
    key: 'SONAR',
  },
  {
    title: 'Apm',
    subTitle: 'Apm监控系统',
    url: 'https://apm.wywk.cn',
    img: arm,
    key: 'APM',
  },
  {
    title: 'Nexus',
    subTitle: 'Nexus私有仓库',
    url: 'https://nexus.ops.wydj.work',
    img: nexus,
    key: 'NEXUS',
  },
  {
    title: 'Cloud',
    subTitle: 'Cloud日志查看平台',
    url: 'https://cloud.wywk.cn',
    img: cloud,
    key: 'CLOUD',
  },
  {
    title: 'Grafana',
    subTitle: 'Grafana监控系统',
    url: 'https://grafana.ops.wydj.work',
    img: grafana,
    key: 'GRAFANA',
  },
  {
    title: 'DMS',
    subTitle: '数据管理平台',
    url: 'https://dms.wywk.cn/',
    img: dba,
    key: 'DMS',
  },
  {
    title: 'Sentry',
    subTitle: '前端监控系统',
    url: 'https://sentry.wywk.cn/',
    img: sentry,
    key: 'SENTRY',
  },
  {
    title: 'NPM',
    subTitle: '前端NPM私服',
    url: 'http://registry-npm.wydj.work/',
    img: npm,
    key: 'NPM',
  },
  {
    title: '前端工具',
    subTitle: '前端在线工具',
    url: 'http://fe-tools.wydj.work/',
    img: feTools,
    key: 'FETOOLS',
  },
  {
    title: '前端组件库',
    subTitle: '前端业务组件库',
    url: 'http://rui-mobile.wydj.work/',
    img: rui,
    key: 'RUI',
  },
  {
    title: '阿里云 UAT',
    subTitle: '阿里云 UAT 环境',
    url:
      'https://wysso.wywk.cn/idp/profile/SAML2/Unsolicited/SSO?providerId=urn:alibaba:cloudcomputing&target=https://homenew.console.aliyun.com/home/uat',
    img: jenkins,
    key: 'ALIUAT',
  },
  {
    title: '阿里云 PROD',
    subTitle: '阿里云国内生产环境',
    url:
      'https://wysso.wywk.cn/idp/profile/SAML2/Unsolicited/SSO?providerId=urn:alibaba:cloudcomputing&target=https://homenew.console.aliyun.com/home/prod',
    img: sso,
    key: 'ALIPROD',
  },
  {
    title: '阿里云 SaaS',
    subTitle: '阿里云海外版 SaaS',
    url:
      'https://wysso.wywk.cn/idp/profile/SAML2/Unsolicited/SSO?providerId=urn:alibaba:cloudcomputing&target=https://homenew.console.aliyun.com/home/sgprod',
    img: ops,
    key: 'ALISASS',
  },
  {
    title: 'MaxCompute',
    subTitle: '大数据开发平台',
    url: 'https://ide2-cn-shanghai.data.aliyun.com/',
    img: max,
    key: 'MAX',
  },
];
